import { brandName } from '../hooks/useCompanyBrand';
// Lead source attribution: the clicked page/CTA is passed explicitly (URL params + session hand-off), never via referrer.
const FRESH_MS = 60000;

const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const pageTitle = () => { const n = brandName(); const t = (document.title || '').trim(); return n ? t.replace(new RegExp(`\\s*[|–-]\\s*${esc(n)}\\s*$`, 'i'), '').trim() : t; };
const read = (k) => { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch { return null; } };

export const currentSource = (cta) => ({
  source_path: window.location.pathname, source_url: window.location.origin + window.location.pathname,
  source_title: pageTitle(), source_cta: (cta || '').slice(0, 120) || null, source_clicked_at: new Date().toISOString(),
});

const makeTracker = ({ prefix, path, direct }) => {
  const PENDING = `${prefix}_pending`, ACTIVE = `${prefix}_active`;
  const DIRECT = { source_path: null, source_url: null, source_title: direct, source_cta: null, source_clicked_at: null };
  let cached = null;
  // Call right before navigating to the form page; returns a tagged href for new-tab opens.
  const mark = (cta) => {
    const s = currentSource(cta);
    try { sessionStorage.setItem(PENDING, JSON.stringify({ ...s, ts: Date.now() })); } catch { /* storage unavailable */ }
    return `${path}?${new URLSearchParams({ src: s.source_path, t: s.source_title, cta: s.source_cta || '', at: s.source_clicked_at })}`;
  };
  // Resolves the source once per visit to the form page and strips tracking params from the address bar.
  const resolve = () => {
    const key = window.history.state?.key || window.location.href;
    if (cached?.key === key) return cached.source;
    const q = new URLSearchParams(window.location.search);
    const pending = read(PENDING);
    let source = DIRECT;
    if (q.get('src')?.startsWith('/')) {
      source = { source_path: q.get('src'), source_url: window.location.origin + q.get('src'), source_title: q.get('t') || null, source_cta: q.get('cta') || null, source_clicked_at: q.get('at') || new Date().toISOString() };
    } else if (pending && Date.now() - pending.ts < FRESH_MS) {
      const { ts, ...rest } = pending;
      source = rest;
    } else if (performance.getEntriesByType?.('navigation')[0]?.type === 'reload' && read(ACTIVE)) {
      source = read(ACTIVE);
    }
    try { sessionStorage.removeItem(PENDING); sessionStorage.setItem(ACTIVE, JSON.stringify(source)); } catch { /* storage unavailable */ }
    if (q.has('src')) {
      q.delete('src'); q.delete('t'); q.delete('cta'); q.delete('at');
      window.history.replaceState(window.history.state, '', window.location.pathname + (q.toString() ? `?${q}` : ''));
    }
    cached = { key, source };
    return source;
  };
  return { path, mark, resolve, DIRECT };
};

export const consultTracker = makeTracker({ prefix: 'consult', path: '/consultation', direct: 'Direct / Consultation Page' });
export const quoteTracker = makeTracker({ prefix: 'quote', path: '/quote', direct: 'Direct / Quote Page' });
export const TRACKERS = [consultTracker, quoteTracker];

export const DIRECT_SOURCE = consultTracker.DIRECT;
export const markConsultSource = consultTracker.mark;
export const resolveConsultSource = consultTracker.resolve;
